import React, { useEffect, useState } from 'react'
import './image-container.styles.scss';
import { getDownloadURL, getStorage, ref } from 'firebase/storage';
import Modal from '@/components/modal/modal.component';

const ImageContainer = ({
  src,
  alt,
  className,
  onClick,
  keyId,
  id,
  title,
  grayscale,
  circle,
  style,
  containerHeight,
  containerWidth,
  preview,
  justifyContent
}) => {

  const [imageSrc, setImageSrc] = useState(null);
  const [showPreview, setShowPreview] = useState(false);
  const [styleObj, setStyleObj] = useState({});
  const storage = getStorage();

  useEffect(() => {
    if (!src) return;
    async function setImageData() {
      if (src.includes('https://') || src.includes('blob:')) {
        setImageSrc(src);
      } else if (src.includes('storage:')) {
        let url = await getDownloadUrlFromPath(src.replace('storage:', ''))
        setImageSrc(url);
      } else {
        setImageSrc(import.meta.env.VITE_ROOT + src)
      }
    }
    setImageData();
  }, [src])

  useEffect(() => {
    let style = {
      justifyContent: justifyContent ?? 'center',
    };
    if (containerHeight) {
      style = {
        ...style,
        height: 'auto',
        maxHeight: containerHeight
      }
    }
    if (containerWidth) {
      style = {
        ...style,
        width: 'auto',
        maxWidth: containerWidth
      }
    }
    setStyleObj(style);
  }, [containerHeight, containerWidth, justifyContent])

  async function getDownloadUrlFromPath(path) {
    getDownloadURL(ref(storage, path))
      .then(url => {
        // This can be downloaded directly:
        const xhr = new XMLHttpRequest();
        xhr.responseType = 'blob';
        xhr.onload = (event) => {
          const blob = xhr.response;
          const urlFromBlob = URL.createObjectURL(blob);
          setImageSrc(urlFromBlob);
        };
        xhr.open('GET', url);
        xhr.send();
      });
    // return urlFromPath;
  }
  return (
    <div 
      className='image-container-div' 
      style={styleObj} >
      {
        (imageSrc) &&
        <img
          id={id ?? null}
          key={keyId}
          src={imageSrc}
          className={`container-image ` +
            (className ?? '') +
            (grayscale ? ' grayscale' : '') +
            (circle ? ' circle' : '')
          }
          alt={alt ?? 'decorative image'}
          referrerPolicy='no-referrer'
          loading='lazy'
          onClick={() => preview ? setShowPreview(true) : null}
          title={title ?? null}
          style={style ?? styleObj}
        // onMouseDown={e => {alert('Image cannot be copied'); return false}}
        />
      }
      {
        (preview && showPreview) &&
        <Modal
          show={showPreview}
          cancel={() => setShowPreview(false)}
          text={`Image Preview ${title ?? ''}`}
          closeButton={true} >
            <div className='modal-image-content'>
              <div className='modal-image-container'>
              <ImageContainer
                src={imageSrc}
                alt={alt ?? 'decorative image'} />
              </div>
            </div>
        </Modal>
      }
    </div>
  )
}

export default ImageContainer